// extracted by mini-css-extract-plugin
export default {"infoPopup":"infoPopup_infoPopup__Ab4Zz","infoPopupText":"infoPopup_infoPopupText__0OMyg","infoPopupImage":"infoPopup_infoPopupImage__04lfS"};